const PendingPropertyPagination = ({
    page,
    totalPages,
    onPageChange,
}) => {
    return (
        <div className="mt-4 flex justify-center gap-3">
            <button
                disabled={page <= 1}
                onClick={() => onPageChange(page - 1)}
            >
                Trang trước
            </button>

            <span>
                Trang {page} / {totalPages}
            </span>

            <button
                disabled={page >= totalPages}
                onClick={() => onPageChange(page + 1)}
            >
                Trang sau
            </button>
        </div>
    );
};

export default PendingPropertyPagination;